import React, { FC, useContext, useEffect } from 'react'
import { AuthButton, IUser } from '@action/auth-button'
import { useTranslations } from 'next-intl'
import { getLogonUrl } from '../../../../utils/common'
import { useEnv } from '../../../../utils/useEnv'
import { APPLICATION_ID } from '../../../../constants/applicationId'
import { LocaleContext } from '../../../../components/LocaleContext/LocaleContext'
import { LanguageContext } from '../../../../components/LanguageContext/LanguageContext'
import style from './RegistrationLayoutProfile.module.css'
import stylesAuthButton from './authButtonStyles.module.css'
import { AuthUserDataContext } from '../../../../components/AuthUserDataContext/AuthUserDataContext'
import { UserContext } from '../../../../components/UserContext/UserContext'

const AUTHORIZATION_BUTTON_TEXT = 'app.formComponents.authorization.buttonText'

type RegistrationLayoutProfileProps = {
  withIsLoginRedirect?: boolean
}

export const RegistrationLayoutProfile: FC<RegistrationLayoutProfileProps> = ({ withIsLoginRedirect = false }) => {
  const t = useTranslations()
  const deployEnv = useEnv()
  const { locale } = useContext(LocaleContext)
  const { language } = useContext(LanguageContext)
  const { authUserData } = useContext(AuthUserDataContext)
  const { user } = useContext(UserContext)
  const { userId } = authUserData

  const handleUserChange = (newUser: IUser) => {
    const userId = authUserData.userId ?? null
    const newUserId = newUser?.id ?? null

    if (!newUserId) {
      const logonUrl = getLogonUrl()

      window.location.assign(`${logonUrl}?lang=${language}`)
    }

    if (userId !== Number(newUserId) && withIsLoginRedirect) {
      window.location.href = `/?lang=${language}`
    }
  }

  useEffect(() => {
    if (userId && withIsLoginRedirect) {
      window.location.href = `/?lang=${language}`
    }
  }, [userId, language, withIsLoginRedirect])

  const authorizationButtonText = t(AUTHORIZATION_BUTTON_TEXT)

  return (
    <span className={style.registrationLayoutProfileContainer}>
      <div className={style.registrationLayoutProfileText}>{authorizationButtonText}</div>
      <AuthButton
        env={deployEnv}
        appId={APPLICATION_ID}
        styles={stylesAuthButton}
        user={user ?? undefined}
        lang={locale}
        onUserChange={handleUserChange}
      />
    </span>
  )
}

RegistrationLayoutProfile.displayName = 'RegistrationLayoutProfile'
